export default {
  zh: {
    common: {
      back: '返回首页'
    },
    authority: {
      warn: '警告！',
      permission: '你没有权限去往该页面...',
      relation: '如果有需要，请联系管理员，获取该页面权限。'
    },
    undefined: {
      bad: '糟糕！',
      inexistence: '啊哦~ 你所访问的页面不存在...',
      examine: '请检查您输入的URL是否正确，或单击下面的按钮返回首页。'
    }
  },
  en: {
    common: {
      back: 'Back homepage'
    },
    authority: {
      warn: 'Warning!',
      permission: "You don't have access to this page...",
      relation: 'If necessary, contact the administrator to obtain the permission for this page.'
    },
    undefined: {
      bad: 'bad!',
      inexistence: 'The page you are visiting does not exist...',
      examine: 'Please check that you entered the correct URL, or click the button below to return to the home page.'
    }
  }
}
